import clsx from 'clsx'
import {FC, useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {DrawerMessenger, ActivityDrawer, InviteUsers, UpgradePlan} from '../partials'
import {MenuComponent} from '../assets/ts/components'
//import {Sidebar} from './components/Sidebar'
import {ThemeModeProvider} from '../partials/layout/theme-mode/ThemeModeProvider'
import {MoleHrModuleRail} from '../../app/shell/MoleHrModuleRail'

const MasterLayout = () => {
  const appTitle = process.env.REACT_APP_TITLE?.toLowerCase()
  const isDsos = appTitle === 'dsos'
  const pageClasses = clsx('page d-flex flex-column-fluid', {
    'flex-row': !isDsos,
    'flex-column flex-lg-row': isDsos,
  })
  const location = useLocation()
  const isCbbeeRoute = location.pathname === '/cbbee' || location.pathname.startsWith('/cbbee/')
  const isMoleSuiteSharedRoute =
    location.pathname === '/workspace' ||
    location.pathname.startsWith('/workspace/') ||
    location.pathname === '/employee-information' ||
    location.pathname.startsWith('/employee-information/') ||
    location.pathname === '/beehive' ||
    location.pathname.startsWith('/beehive/')
  const isMoleSuiteProductRoute =
    location.pathname === '/dashboard' ||
    location.pathname === '/organization' ||
    location.pathname.startsWith('/organization/') ||
    location.pathname === '/select' ||
    location.pathname.startsWith('/select/') ||
    location.pathname === '/talent' ||
    location.pathname.startsWith('/talent/') ||
    location.pathname === '/performance' ||
    location.pathname.startsWith('/performance/') ||
    isMoleSuiteSharedRoute ||
    isCbbeeRoute

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root'>
          <div className={pageClasses}>
            {isMoleSuiteProductRoute ? (
              <MoleHrModuleRail />
            ) : (
              <AsideDefault hideMenuContent={isDsos} />
            )}
            <div
              className={clsx('wrapper d-flex flex-column flex-row-fluid', {
                'cbbee-wrapper': isCbbeeRoute,
                'molehr-product-wrapper': isMoleSuiteProductRoute,
              })}
              id='kt_wrapper'
            >
              {!isMoleSuiteProductRoute && <HeaderWrapper />}

              <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
                <Content>
                  {isDsos && <DsosNotice />}
                  <Outlet />
                </Content>
              </div>
              {!isMoleSuiteProductRoute && <Footer />}
            </div>
          </div>
        </div>

        {/* begin:: Drawers */}
        <ActivityDrawer />
        <RightToolbar />
        <DrawerMessenger />
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        <InviteUsers />
        <UpgradePlan />
        {/* end:: Modals */}
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

const DsosNoticeMessage: FC = () => (
  <>
    <span className='fs-5 fs-lg-4 fw-bold text-primary mb-3 mb-lg-4'>Bilgilendirme</span>
    <p className='fs-7 fs-lg-6 text-gray-700 mb-0'>
      Bu uygulamadan yalnızca sınav ve dersliklerin organizasyonu ile ilgili işlemler
      yapılabilmektedir. Ölçme ve değerlendirme sistemi, Anket sistemi ve diğer kalite süreçleri
      için Yükseköğretimde Kalite Yönetim Sistemi'ne giriş yapmalısınız.
    </p>
  </>
)

const DsosNotice: FC = () => {
  return (
    <div className='d-flex flex-column flex-lg-row gap-3 gap-lg-5 align-items-start align-items-lg-center text-center text-lg-start px-5 py-5 mb-6 bg-light border border-dashed border-primary border-2 rounded-3'>
      <DsosNoticeMessage />
    </div>
  )
}

export {MasterLayout}
